export const decimalFormat = new RegExp('^\\d*\\.?\\d*$')
export const decimalLeadingZeroFormat = new RegExp('^0\\d+')
export const decimalExceedsMaxScale = new RegExp('^\\d*\\.\\d\\d\\d$')

export function isDigit(str, ix) {
  return str.length > ix && !isNaN(str.charAt(ix))
}

export function endsWithDigit(str) {
  return str.length > 0 && !isNaN(str.charAt(str.length - 1))
}

export function startsWithDigit(str) {
  return str.length > 0 && !isNaN(str.charAt(0))
}

export function toFixedDecimal(num, digits, base) {
  const pow = Math.pow(base ?? 10, digits ?? 2);
  return Math.round(num*pow) / pow;
}

export function toFixedWholePercent(num, digits, base) {
  return toFixedDecimal(num * 100, digits, base)
}

export function normalizeDecimalString(decimalStr) {
  let outputDecimalStr = decimalStr.trim()
  if (outputDecimalStr !== '' && !decimalFormat.test(outputDecimalStr)) {
    return undefined
  }
  if (outputDecimalStr === '') {
    outputDecimalStr = '0'
  }
  if (outputDecimalStr.startsWith('.')) {
    outputDecimalStr = `0${outputDecimalStr}`
  } else if (decimalLeadingZeroFormat.test(outputDecimalStr)) {
    outputDecimalStr = outputDecimalStr.substring(1)
  }
  if (decimalExceedsMaxScale.test(outputDecimalStr)) {
    outputDecimalStr = `${toFixedDecimal(parseFloat(outputDecimalStr))}`
  }
  return outputDecimalStr
}

export function formatZeroFillDecimal(decimal, formatNumDigits) {
  let inputNumDigits = `${decimal}`.length
  let preZero = ''
  for (let i = inputNumDigits; i < formatNumDigits; i++) {
    preZero += '0'
  }
  return `${preZero}${decimal}`
}

export function formatDollarDecimal(decimal) {
  const parts = `${decimal}`.split('.')
  let fraction = parts.length === 2 ? parts[1] : ''
  while (fraction.length < 2) {
    fraction = `${fraction}0`
  }
  return `$${parts[0]}.${fraction}`
}

export function trimZeroesDecimalStr(decimalStr) {
  const decimalPartsArr = decimalStr.split('.')
  let wholePart = decimalPartsArr[0]
  let trimWholeIx = 0
  while (trimWholeIx < wholePart.length) {
    if (wholePart.charAt(trimWholeIx) !== '0') {
      break
    }
    ++trimWholeIx
  }
  wholePart = trimWholeIx >= wholePart.length ? '0' : wholePart.substring(trimWholeIx)

  let fractionPart = ''
  if (decimalPartsArr.length > 1) {
    fractionPart = decimalPartsArr[1]
  }
  let trimFractionIx = fractionPart.length - 1
  while (trimFractionIx >= 0) {
    if (fractionPart.charAt(trimFractionIx) !== '0') {
      break
    }
    --trimFractionIx
  }
  fractionPart = trimFractionIx < 0 ? '' : fractionPart.substring(0, trimFractionIx + 1)
  return fractionPart === '' ? wholePart : `${wholePart}.${fractionPart}`
}
